import { LineItemNumericCalculatorField } from "components/formFields/LineItemNumericCalculatorField";
import { LineTableCell } from "components/formFields/LineTableCell";

import { LINE_ITEM_METADATA } from "editConfig";

export function LineProduced(props) {
  const { value, onValueChange, objectType, lineReadOnly } = props;

  return (
    <LineTableCell sx={{ minWidth: "7rem" }}>
      <LineItemNumericCalculatorField
        name="produced"
        value={value}
        onValueChange={onValueChange}
        metadata={LINE_ITEM_METADATA[objectType].produced}
        lineReadOnly={lineReadOnly}
      />
    </LineTableCell>
  );
}
